export type ShiftStatus = "unknown" | "open" | "closed"

export interface ShiftStatusSnapshot {
  shopId: number | null
  status: ShiftStatus
  checkedAt: number | null
}

export function createUnknownShiftStatusSnapshot(): ShiftStatusSnapshot {
  return {
    shopId: null,
    status: "unknown",
    checkedAt: null,
  }
}

export function createShiftStatusSnapshot(
  shopId: number,
  status: Exclude<ShiftStatus, "unknown">,
  checkedAt = Date.now(),
): ShiftStatusSnapshot {
  return {
    shopId,
    status,
    checkedAt,
  }
}

export function resolveShiftStatusForShop(snapshot: ShiftStatusSnapshot, shopId: number): ShiftStatus {
  if (!Number.isFinite(shopId) || shopId <= 0 || snapshot.shopId !== shopId) {
    return "unknown"
  }
  return snapshot.status
}

interface ApplyShiftOpenResultOptions {
  targetShopId: number
  currentShopId: number
  isOpen: boolean
  snapshot: ShiftStatusSnapshot
  setOpen: (isOpen: boolean, targetShopId: number) => void
  resetShiftStatus: () => void
}

export function applyShiftOpenResult({
  targetShopId,
  currentShopId,
  isOpen,
  snapshot,
  setOpen,
  resetShiftStatus,
}: ApplyShiftOpenResultOptions) {
  const targetIsValid = Number.isFinite(targetShopId) && targetShopId > 0
  if (!targetIsValid || currentShopId !== targetShopId) {
    if (resolveShiftStatusForShop(snapshot, currentShopId) === "unknown") {
      resetShiftStatus()
    }
    return false
  }
  setOpen(isOpen, targetShopId)
  return true
}
